// src/components/LiveBalanceBar.jsx
import React from 'react';
import './TableList.css';

export default function LiveBalanceBar({
  amount = 0,
  loading = false,
  prevAmount = null
}) {
  const increased = prevAmount !== null && amount > prevAmount;
  const decreased = prevAmount !== null && amount < prevAmount;
  const isLow = amount < 100;

  return (
    <div
      className={[
        'live-balance',
        isLow ? 'low' : 'ok',
        increased ? 'up' : '',
        decreased ? 'down' : '',
      ].join(' ')}
    >
      <div className="live-balance-label">
        Sold curent
        <span className="live-dot" />
      </div>

      <div className="live-balance-amount">
        {loading ? '…' : `${amount.toFixed(2)} RON`}
      </div>
    </div>
  );
}
